import {styled} from "@mui/material/styles"

export const ImageWrapper = styled("div")`
    padding: 0 1rem 1rem 1rem;
`
